export const paidProductCodes = [
    100, 108, 109, 110, 111, 112, 97, 96, 101, 98, 99, 102, 107
];
